import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/master-data/legal-entities')({
  component: Outlet
})
